import { isTooManyRequestsError } from './errors';

/** After a 429, avoid hammering the same endpoint for this long. */
export const SDK_RATE_LIMIT_COOLDOWN_MS = 60 * 1000;

/** Reuse successful review/listing fetches for this long. */
export const SDK_FETCH_CACHE_MS = 5 * 60 * 1000;

export const isSdk429Error = error =>
  isTooManyRequestsError(error) ||
  error?.response?.status === 429 ||
  error?.status === 429;

export const sdkRateLimitUntil = (fromMs = Date.now()) => fromMs + SDK_RATE_LIMIT_COOLDOWN_MS;

export const isSdkFetchCached = (fetchedAt, now = Date.now()) =>
  typeof fetchedAt === 'number' && now - fetchedAt < SDK_FETCH_CACHE_MS;

export const isSdkRateLimited = (rateLimitedUntil, now = Date.now()) =>
  typeof rateLimitedUntil === 'number' && now < rateLimitedUntil;
